/**
 * NotFoundPage — fallback for unknown routes.
 */
import { Button } from "@melusine/shared-ui";
import { routes, useNavigate } from "@shared/router";

import styles from "./NotFoundPage.module.css";

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className={styles.page}>
      <span className={styles.glyph} aria-hidden="true">
        ✦
      </span>
      <p className={styles.text}>Страница не найдена</p>
      <Button
        variant="primary"
        onClick={() => {
          navigate(routes.home());
        }}
      >
        На главную
      </Button>
    </div>
  );
}
